module.exports = __webpack_public_path__ + "static/lenins-tomb-ab49acb30514c6913d1c09e9d0803b3b.jpg";